const translations = {
    Add: 'Thêm',
    Remove: 'Xoá',
    Change: 'Thay đổi',
    Save: 'Lưu',
    Cancel: 'Hủy',
    'Save Changes': 'Lưu Thay Đổi',
    'Save changes!': 'Lưu Thay Đổi!',
    'Hide Profile': 'Ẩn Hồ Sơ',
    'Hide My Profile': 'Ẩn Hồ Sơ Của Tôi',
    'To these companies': 'Với những công ty  này',
    'Add a company to hide your CV': 'Thêm công ty để ẩn hồ sơ',
    'Add company': 'Thêm công ty',
    'Enter at least 3 letters': 'Hãy nhập ít nhất 3 ký tự tên của công ty',
    "Sorry can't add more than 9": 'Xin lỗi, bạn không thể thêm hơn 9 công ty',
    'Max number of {0} companies reached': 'Được thêm tối đa {0} nhà tuyển dụng',
    'Please delete first before add other companies': 'Hãy xoá bớt trước khi thêm nhà tuyển dụng khác',
    'Loading...': 'Đang tải...',
    'No result found...': 'Không có kết quả...',
    'No options': 'Không có lựa chọn',
    "Enter company's email domain": 'Nhập domain email công ty',
    Recommended: 'Được đề nghị',
    Status: 'Trạng thái',
    On: 'Bật',
    Off: 'Tắt',
    'Or enter a company name': 'Hoặc nhập tên công ty',
    'At least 3 letters': 'Ít nhất 3 ký tự',
    'Hide My profile from Company': 'Ẩn hồ sơ của tôi với các công ty',
    'Listing the company that you do not allow searching your cv.': 'Danh sách công ty',
    'Profile Settings': 'Thiết lập hồ sơ',
    'Your resume': 'Hồ sơ của bạn',
    'was uploaded on': 'được cập nhật ngày',
    Upload: 'Tải hồ sơ',
    'Upload CV': 'Tải CV lên',
    'You can only attach .doc, .docx, and .pdf files that are less than 2MB in size':
        'Định dạng file chỉ có thể là .doc, .docx và pdf, files phải nhỏ hơn 2MB.',
    Searchable: 'Cho phép tìm kiếm',
    'You can track who viewed your profile': 'Bạn có thể theo dõi được ai đã xem hồ sơ của bạn',
    'Your Searchable Profile': 'Hồ sơ cho phép tìm kiếm của bạn',
    'Searchable Profile': 'Cho phép tìm kiếm hồ sơ',
    'Online Resume': 'Hồ sơ online',
    'Attached Resume': 'Hồ sơ đính kèm',
    'Your Attached CV': 'Hồ Sơ Đính Kèm',
    'Attached CV': 'Hồ sơ đính kèm',
    'Work Preferences': 'Công việc mong muốn',
    'Contact Information': 'Thông tin liên hệ',
    'VietnamWorks profile': 'Hồ sơ VietnamWorks',
    'Make Your Profile Searchable': 'Bật cho phép tìm kiếm hồ sơ',
    'Make your profile searchable to increase your visibility to employers':
        'Hồ sơ của bạn sẽ không hiển thị cho nhà tuyển dụng',
    'Add more information to be able to make this attached CV searchable.':
        'Hãy nhập thêm thông tin để nhà tuyển dụng có thể tìm kiếm hồ sơ của bạn.',
    'Update Basic Info': 'Cập Nhật Hồ Sơ',
    'Preferred working location': 'Nơi Làm Việc Mong Muốn',
    'Please select': 'Vui lòng chọn',
    'City / Province': 'Tỉnh / Thành Phố',
    'District / Ward': 'Quận / Huyện',
    'No matches found': 'Không tìm thấy kết quả',
    'You can only select maximum of 3 options': 'Bạn chỉ có thể chọn tối đa 3 lựa chọn',
    'All Districts': 'Tất Cả Các Quận / Huyện',
    'All cities / provinces': 'Tất cả các tỉnh / thành phố',
    'All districts / wards': 'Tất cả các quận / huyện',
    Download: 'Tải Xuống',
    Close: 'Đóng',
    'and is being processed.': 'và đang được xử lý.',
    Updated: 'Đã cập nhật',
    Uploaded: 'Đã tải lên',
    'Update Attached CV': 'Thay đổi CV đính kèm',
    'Change CV': 'Thay đổi hồ sơ',
    'Do You Have Your Own CV?': 'Bạn đã có CV?',
    'Upload and use your existing CV for the quick apply.': 'Tải lên CV để có thể ứng tuyển nhanh chóng',
    'Upload Your CV': 'Tải lên CV',
    Size: 'Kích thước',
    View: 'Xem',
    "The profile will be automatically refreshed and on top of the Employer's candidate search page within 15 days from the date of enabling the feature.":
        'Hồ sơ sẽ được tự động làm mới và lên đầu trang tìm kiếm ứng viên của Nhà tuyển dụng trong 15 ngày từ ngày bật tính năng.',
    "The profile will be automatically refreshed and will be on the top of the Employer's candidate search page until":
        'Hồ sơ sẽ được tự động làm mới và lên đầu trang tìm kiếm ứng viên của Nhà tuyển dụng cho đến ngày',
    "You need to turn on searchable mode before using this feature to ensure your profile will be displayed on Employer's candidate search page":
        'Bạn cần bật tính năng cho phép tìm kiếm hồ sơ trước khi sử dụng tính năng này để đảm bảo hồ sơ của bạn hiển thị trên trang tìm kiếm ứng viên của Nhà tuyển dụng.',
    'Refresh my profile Daily': 'Làm mới hồ sơ hàng ngày',
    'Refresh my profile Weekly': 'Làm mới hồ sơ hàng tuần',
    'Refresh Daily': 'Làm mới ngày',
    'Refresh Weekly': 'Làm mới tuần',
    'Turn Off Refresh': 'Tắt làm mới',
    'By VietnamWorks profile': 'Bằng hồ sơ VietnamWorks',
    'By attached CVs': 'Bằng hồ sơ đính kèm',
    'Refresh My Profile': 'Làm mới hồ sơ',
    'Manage attached CVs': 'Quản lý hồ sơ đính kèm',
    'Searchable by Attached CV': 'Cho phép tìm kiếm hồ sơ đính kèm',
    'To enable Attached CV, you need to complete:': 'Để bật cho phép tìm kiếm hồ sơ đính kèm, bạn cần cung cấp:',
    'To enable VietnamWorks Profile, your VietnamWorks Profile needs to be completed and approved.':
        'Để bật cho phép tìm kiếm, hồ sơ trực tuyến VietnamWorks cần được hoàn thiện và được duyệt',
    'Update profile': 'Cập nhật hồ sơ',
    Unfinished: 'Chưa hoàn chỉnh',
    Beginner: 'Cơ bản',
    Intermediate: 'Trung bình',
    Expert: 'Tương đối hoàn chỉnh',
    'All Star': 'Hoàn chỉnh',
    completed: 'đã hoàn thành',
    'Searchable status': 'Trạng thái cho phép tìm kiếm',
    '/my-profile': '/ho-so',
    'Not Approved': 'Chưa được duyệt',
    Done: 'Hoàn tất',
    'Refresh status': 'Trạng thái làm mới hồ sơ',
    'Refresh profile': 'Làm mới hồ sơ',
    'File name': 'Tên tập tin',
    'job-search/all-jobs': 'tim-viec-lam/tim-tat-ca-viec-lam',
    'To enable Searchable Profile, get your profile approved or complete: Attached CV, Contact Information and Work Preferences.':
        'Để cho phép nhà tuyển dụng tìm kiếm hồ sơ, hãy cập nhật hồ sơ trực tuyến VietnamWorks hoặc nhập các thông tin: "Hồ sơ đính kèm", "Thông tin liên hệ" và "Công việc mong muốn"',
    'Turn on and allow employers to view your profile.': 'Bật và cho phép nhà tuyển dụng xem hồ sơ của bạn.',
    'Default searchable': 'Tìm kiếm hồ sơ mặc định',
    'Searchable CV': 'Cho phép tìm kiếm hồ sơ',
    'Default searchable CV': 'Hồ sơ tìm kiếm mặc định',
    'Searchable CVs': 'Cho phép tìm kiếm hồ sơ',
    'Turn off searchable CV?': 'Tắt tìm kiếm hồ sơ?',
    'Employer will not see your profile on Vietnamwork system.':
        'Nhà tuyển dụng sẽ không tìm kiếm được hồ sơ của bạn trên hệ thống Vietnamworks.',
    'You can add a maximum of': 'Bạn chỉ có thể nhập tối đa',
    'email domains': 'domain email',
    'Please select a job level': 'Vui lòng chọn trình độ công việc',
    'Searchable CV is disable': 'Tính năng bật tìm kiếm đang bị khoá',
    'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:':
        'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:',
    'Local Vietnamese': 'Người Việt Nam',
    Foreigner: 'Người nước ngoài',
    'Your changes has been saved successfully!': 'Thay đổi của bạn đã được lưu thành công',
    'Something went wrong with your change!': 'Đã xảy ra lỗi với thay đổi của bạn',
    Success: 'Thành công',
    Error: 'Lỗi',
    'Select attached CVs': 'Chọn CV đã tải lên',
    'Updated on': 'Cập nhật ',
    'To make attached CV searchable, you need to:': 'Để cho phép tìm kiếm hồ sơ đính kèm, bạn cần thực hiện:',
    'Complete basic information': 'Bổ sung thông tin cơ bản',
    'View CV': 'Xem hồ sơ',
    'View as employer': 'Xem như nhà tuyển dụng',
    'preview-resume': 'xem-truoc-ho-so',
    'Job-seeking status': 'Trạng thái tìm việc',
    'New': 'Mới',
    'I am open to work': 'Tôi đang tìm việc mới',
    'Select Open to work to attract more employers':
        'Chọn trạng thái đang tìm việc giúp hồ sơ bạn được chú ý nhiều hơn',
    'The status is set until': 'Trạng thái này sẽ được thiết lập đến ngày'
}

export default translations
